import React from "react";
import ItemsTable from "./ItemsTable";

const Table = ({ data } ) => (
    <ItemsTable tableData={data} />
);

export default Table;